import React from 'react'

const Resturents = () => {
    return (
        <div>Resturents</div>
    )
}

export default Resturents